const ISO_DATE_PATTERN =
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})/g;

/**
 * Replaces ISO dates inside assistant text with localized, readable dates.
 */
export const formatAssistantDates = (
    value: string | undefined,
    language: string
): string | undefined => {
    if (typeof value !== 'string') return value;
    return value.replace(ISO_DATE_PATTERN, (isoDate) => {
        const date = new Date(isoDate);
        return Number.isNaN(date.getTime())
            ? isoDate
            : new Intl.DateTimeFormat(language, {
                  dateStyle: 'medium',
                  timeStyle: 'short',
              }).format(date);
    });
};
